import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img 
            src="/icons/two rings.png" 
            alt="I Love You" 
            className="footer-love-icon"
          />
        </div>
        
        <div className="footer-right">
          <p className="footer-text">
            Created with{' '}
            <img 
              src="/icons/heart with wings (front).png" 
              alt="love" 
              className="footer-heart-icon"
            />
            {' '}by{' '}
            <a 
              href="https://prathik.xtoicstudio.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              Prathik
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;